import { render, staticRenderFns } from "./AspectPage.vue?vue&type=template&id=e8244db4"
import script from "./AspectPage.vue?vue&type=script&lang=js"
export * from "./AspectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports